import React from 'react';
import { TestimonialCardProps } from '../types';

const TestimonialCard: React.FC<TestimonialCardProps> = ({
  card,
  onCardClick,
}) => {
  return (
    <div className="flex-shrink-0 border-t-4 border-blue-350 mx-4 mt-4 mb-24 sm:m-3 min-w-[300px] bg-white rounded-lg shadow-md h-[350px] sm:h-[375px]">
      <div className="w-full flex justify-between items-center sm:flex-col-reverse p-4 px-3">
        <div className="flex flex-col w-full h-full justify-between">
          <h5
            className="text-xl font-semibold mb-4"
            dangerouslySetInnerHTML={{ __html: card.title }}
          />
          <div
            className="text-base text-gray-700 mb-6 sm:text-sm"
            dangerouslySetInnerHTML={{ __html: card.description }}
          />
          <div className="py-2">
            <div className="sm:flex-col sm:flex">
              <div className="flex items-center">
                <div className="w-14 h-14 rounded-full overflow-hidden">
                  <img
                    width="56"
                    src={card.image1}
                    alt={card.image1Alt}
                    loading="lazy"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="ml-4">
                  <p className="font-bold text-gray-800">{card.customer}</p>
                  <div className="text-sm text-gray-500 md:text-xs sm:text-xs">
                    {card.location}
                  </div>
                </div>
              </div>
              <a
                onClick={(e) => onCardClick(card, e)}
                href={`/${card.link}`}
                className="text-blue-600 pt-4 sm:ml-0 inline-block font-bold"
                dangerouslySetInnerHTML={{ __html: card.message }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TestimonialCard;
